import React from 'react';
import PropTypes from 'prop-types';

const CategoricalComponent = props =>
  <div className="content-item">
    <table
      className="main-table"
      id="levels-summary-table"
    >
      <colgroup>
        <col className="bg-grey-150" />
      </colgroup>

      <thead>
        <tr>
          <th className="text-right">Levels of {props.parameterName}</th>

          {props.levelsSummary.map(({ name }) =>
            <th className="text-right" key={name}>{name}</th>
          )}
        </tr>
      </thead>

      <tbody>
        <tr>
          <td className="font-13 font-700">Frequency</td>

          {props.levelsSummary.map(({ name, count }) =>
            <td key={name} id={`${name}-count`} className="text-right">
              {count}
            </td>
          )}
        </tr>

        <tr>
          <td className="font-13 font-700">Relative Frequency</td>

          {props.levelsSummary.map(({ name, proportion }) =>
            <td key={name} className="text-right" id={`${name}-proportion`}>
              {parseFloat(proportion.toFixed(4))}
            </td>
          )}
        </tr>
      </tbody>
    </table>
  </div>;

CategoricalComponent.propTypes = {
  levelsSummary: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      proportion: PropTypes.number.isRequired
    })
  ).isRequired,
  parameterName: PropTypes.string.isRequired
};

export default CategoricalComponent;
